import { Table } from "@bphxd/ds-core-react";
import { useState, useEffect } from "react";

export default function QNAPagination({
  totalCount,
  pageSize,
  onPageChange,
}: {
  totalCount: number;
  pageSize: number;
  onPageChange: (offset: number, idx: number) => void;
}) {
  const [pagination, setPagination] = useState({
    index: 0,
    size: pageSize,
  });

  // ✅ Reset when backend data changes
  useEffect(() => {
    setPagination({
      index: 0,
      size: pageSize,
    });
  }, [totalCount, pageSize]);

  const onPageIndexChange = (index: number) => {
    setPagination((prev) => ({ ...prev, index }));

    // ✅ dynamic offset calculation
    onPageChange(index * pagination.size, index);
  };

  return (
    <div style={{ display: "flex",justifyContent:"flex-end", marginTop: "10px" ,fontSize:"14px"}}>
      <Table.Pagination
        onPageIndexChange={onPageIndexChange}
        pageIndex={pagination.index}
        pageSize={pagination.size}
        totalCount={totalCount}
      />
    </div>
  );
}